import { supabase } from '@/integrations/supabase/client';

export const checkDatabaseSeed = async (): Promise<{
  hasContent: boolean;
  counts: {
    syllabus: number;
    lessons: number;
    quizzes: number;
  };
}> => {
  const [syllabusResult, lessonsResult, quizzesResult] = await Promise.all([
    supabase.from('syllabus_content').select('*', { count: 'exact', head: true }),
    supabase.from('lessons').select('*', { count: 'exact', head: true }),
    supabase.from('quizzes').select('*', { count: 'exact', head: true }),
  ]);

  const counts = {
    syllabus: syllabusResult.count || 0,
    lessons: lessonsResult.count || 0,
    quizzes: quizzesResult.count || 0,
  };

  return {
    hasContent: counts.syllabus > 0,
    counts,
  };
};
